/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../api/sync/sync';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "api": {
        "nested": {
          "items": {
            "nested": {
              "EnablingActionType": {
                "values": {
                  "UNKNOWN_ENABLING_ACTION_TYPE": 0,
                  "DISABLE": 1,
                  "ADJUSTMENT": 2
                }
              },
              "ObjectFilter": {
                "values": {
                  "UNKNOWN_OBJECT_FILTER": 0,
                  "ALL": 1,
                  "INCLUDE": 2
                }
              },
              "ItemSetConfiguration": {
                "fields": {
                  "filter": {
                    "type": ".squareup.api.items.ObjectFilter",
                    "id": 1,
                    "rule": "optional"
                  },
                  "item": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "appliesToCustomAmounts": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "TaxSetConfiguration": {
                "fields": {
                  "filter": {
                    "type": ".squareup.api.items.ObjectFilter",
                    "id": 1,
                    "rule": "optional"
                  },
                  "tax": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ObjectPredicate": {
                "fields": {
                  "type": {
                    "type": ".squareup.api.items.ObjectPredicate.Type",
                    "id": 1,
                    "rule": "optional"
                  },
                  "objectId": {
                    "type": ".squareup.api.sync.ObjectId",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "UNKNOWN": 0,
                      "IN": 1
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.EnablingActionType && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ObjectFilter && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ItemSetConfiguration && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.TaxSetConfiguration && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ObjectPredicate && !$root.nested?.squareup?.nested?.api?.nested?.items?.nested?.ObjectPredicate?.nested?.Type) {
  $root.addJSON(jsonData);
}

/**
 * An enable/disable action to take for a rule. Use enum instead of boolean to be explicit.
 *
 * SOURCE EnablingActionType @ squareup/items/rule_types.proto at 16:1
 */
export const EnablingActionType = $root.lookupEnum('squareup.api.items.EnablingActionType').values;
/**
 * SOURCE ObjectFilter @ squareup/items/rule_types.proto at 24:1
 */
export const ObjectFilter = $root.lookupEnum('squareup.api.items.ObjectFilter').values;
/**
 * Configuration with a filter to define a set of item objects.
 *
 * SOURCE ItemSetConfiguration @ squareup/items/rule_types.proto at 45:1
 */
export const ItemSetConfiguration = $root.lookupType('squareup.api.items.ItemSetConfiguration');
fixType(ItemSetConfiguration);
Builder.createAndAttachToType(ItemSetConfiguration);
/**
 * Configuration with a filter to define a set of tax objects (fees with type
 * TAX AdjustmentType).
 *
 * SOURCE TaxSetConfiguration @ squareup/items/rule_types.proto at 63:1
 */
export const TaxSetConfiguration = $root.lookupType('squareup.api.items.TaxSetConfiguration');
fixType(TaxSetConfiguration);
Builder.createAndAttachToType(TaxSetConfiguration);
/**
 * SOURCE ObjectPredicate @ squareup/items/rule_types.proto at 70:1
 */
export const ObjectPredicate = $root.lookupType('squareup.api.items.ObjectPredicate');
fixType(ObjectPredicate);
Builder.createAndAttachToType(ObjectPredicate);
/**
 * SOURCE Type @ squareup/items/rule_types.proto at 71:3
 */
ObjectPredicate.Type = $root.lookupEnum('squareup.api.items.ObjectPredicate.Type').values;